import { useCallback, useEffect } from 'react';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';

const useHelpMenuPin = (router) => {
  const { Appcues } = window;
  const { pushParamsToHistory } = useNavigation({
    router,
  });

  const onButtonClick = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      pushParamsToHistory({
        contactus: 'show',
      });
    },
    [pushParamsToHistory],
  );

  useEffect(() => {
    if (Appcues && Appcues.on) {
      const getShadowElement = (experienceId) => {
        const container = document.querySelector(
          `appcues-experience-container#appcues-container-${experienceId}`,
        );
        return container.shadowRoot;
      };

      Appcues.on('v2:icon_seen', (event) => {
        const { experienceId } = event;
        const shadowElement = getShadowElement(experienceId);
        if (shadowElement) {
          const pinBeaconElement = shadowElement.querySelector(
            '.pin-beacon:not(.custom-pin-beacon)',
          );
          if (pinBeaconElement) {
            pinBeaconElement.classList.add('custom-pin-beacon');
            pinBeaconElement.style['z-index'] = '9999';
          }
        }
      });
      const captureButton = (shadowElement, stepId) => {
        if (shadowElement && shadowElement.innerHTML.includes('<div')) {
          const rowContainersElement = shadowElement.querySelector(
            `div[data-appcues-container-id="appcues-container-${stepId}"]`,
          );
          if (rowContainersElement) {
            const toolTipContent =
              rowContainersElement.querySelector('.tooltip-content');
            if (toolTipContent) {
              const MIN_HEIGHT = 200;
              const BOTTOM_GAP = 40;
              const { top } = toolTipContent.getBoundingClientRect();
              if (window.innerHeight < MIN_HEIGHT) {
                toolTipContent.style.height = '200px';
              } else {
                const containerHeight =
                  toolTipContent.offsetHeight + top + BOTTOM_GAP;
                if (containerHeight > window.innerHeight) {
                  //if it doesn't fit in the window, resize the container
                  toolTipContent.style.height = `${
                    window.innerHeight - top - BOTTOM_GAP
                  }px`;
                }
              }
              window.toolTipContent = toolTipContent;
              toolTipContent.style.overflowY = 'auto';
              toolTipContent.style.overflowX = 'hidden';
            }
            const buttonContainer = rowContainersElement.querySelector(
              '.canvas .row-container:nth-last-child(1)',
            );
            if (buttonContainer) {
              buttonContainer.style.position = 'sticky';
              buttonContainer.style.bottom = '0';
              buttonContainer.style.background = '#FFF';
              const button = buttonContainer.querySelector('a[role="button"]');
              if (button && !button.hasAttribute('data-captured')) {
                button.closest('div').style.marginTop = '8px';
                button.setAttribute('data-captured', 'yes');
                button.addEventListener('click', onButtonClick, true);
                return button;
              }
            }
          }
        }
      };

      Appcues.on('v2:step_seen', (event) => {
        //Used to find the experience container
        const { experienceId, stepId } = event;
        const shadowElement = getShadowElement(experienceId);
        const button = captureButton(shadowElement, stepId);
        //When the appcues pin is configured with the inline option
        //the shadow element for the current pin contains only stylesheets
        //and stepId needs to be used in this case
        //in which case the button is found in the container with the same stepId equal with the experienceId
        if (!button) {
          const stepShadowElement = getShadowElement(stepId, stepId);
          captureButton(stepShadowElement, stepId);
        }
      });

      return () => {
        Appcues.off('v2:icon_seen');
        Appcues.off('v2:step_seen');
      };
    }
  }, [Appcues, onButtonClick]);

  return [];
};

useHelpMenuPin.propTypes = {};

export default useHelpMenuPin;
